/**
 * Checks if a string is null, undefined or empty. Performs a nullsafe
 * check on the string as part of the check.
 * @param str1
 * @param str2
 */
export function equalsIgnoreCase(str1: string | null, str2: string | null): boolean {
  return str1?.toLowerCase() === str2?.toLowerCase();
}

/**
 * Checks if a string is empty, null, undefined or has a length of 0 after trimming it.
 * @param str
 */
export function isEmpty(str: string | null | undefined): boolean {
  return !str || str.trim().length === 0;
}

/**
 * Checks if a string is not empty, null, undefined and has a length greater than 0 after trimming it.
 * @param str
 */
export function isNotEmpty(str: string | null | undefined): boolean {
  return !isEmpty(str);
}

/**
 * Checks if any of the strings are empty, null, undefined or have a length of 0 after trimming them.
 */
export function anyEmpty(...strings: string[]): boolean {
  return strings.some(isEmpty);
}

/**
 * Checks if all the strings are empty, null, undefined or have a length of 0 after trimming them.
 */
export function allEmpty(...strings: string[]): boolean {
  return strings.every(isEmpty);
}

/**
 * Checks if none of the string are empty, null, undefined or have a length of 0 after trimming them.
 * @param strings
 */
export function noneEmpty(...strings: string[]): boolean {
  return strings.every(isNotEmpty);
}

/**
 * Trims a string and returns it.
 * trimToNull(null) = null
 * trimToNull(undefined) = null
 * trimToNull('') = null
 * trimToNull('  ') = null
 * trimToNull('  a  ') = 'a'
 */
export function trimToNull(str: string | null | undefined): string | null {
  str = str?.trim() ?? null;
  return isEmpty(str) ? null : str;
}
